import React from 'react';
const comparisonRows = [{
  situation: 'Tu foco',
  without: 'Secuestrado por el algoritmo',
  with: 'Blindado con Modo Antialgoritmo'
}, {
  situation: 'Tus mañanas',
  without: 'Celular antes de levantarte',
  with: 'Protocolo de arranque en 3 min'
}, {
  situation: 'Tu energía',
  without: 'Dopamina quemada desde las 9 AM',
  with: 'Reset dopamínico activo todo el día'
}, {
  situation: 'Tus proyectos',
  without: 'Parados hace meses',
  with: 'Sistema de 3 Bloques ejecutando'
}, {
  situation: 'Tus noches',
  without: 'Nudo en el estómago y culpa',
  with: 'Protocolo de apagado mental 7 min'
}, {
  situation: 'Tu progreso',
  without: 'Sin métricas ni seguimiento',
  with: 'Tablero de control a 90 días'
}, {
  situation: 'Las recaídas',
  without: 'Sin plan de rescate',
  with: 'Protocolo S.O.S. Anti-Recaída'
}, {
  situation: 'Tu identidad',
  without: 'El que "está por empezar"',
  with: 'El que siempre TERMINA'
}];
const blocks = [{
  emoji: '🧬',
  title: 'Bloque 1 — Reset Dopamínico',
  desc: 'Protocolo de 7 días para limpiar tus receptores y recuperar el placer de hacer cosas difíciles.',
  span: false
}, {
  emoji: '🏗️',
  title: 'Bloque 2 — Ingeniería de Entorno',
  desc: 'Rediseñá tu espacio físico y digital para que el foco sea inevitable y la distracción sea difícil.',
  span: false
}, {
  emoji: '⏰',
  title: 'Bloque 3 — Sistema de 3 Bloques',
  desc: 'El método para ejecutar en 90 minutos lo que antes te llevaba una semana entera.',
  span: false
}, {
  emoji: '🚨',
  title: 'Bloque 4 — Protocolo S.O.S.',
  desc: 'El sistema de rescate para los días que la motivación desaparece y todo parece imposible.',
  span: false
}, {
  emoji: '📊',
  title: 'Assets incluidos en el PRO:',
  desc: 'Tablero 90 días · Checklist diario · Checklist semanal · Scripts de arranque · Protocolo de apagado · Mapa de hábitos · Plan anti-recaída personalizado',
  span: true
}];
export function ProBusiness() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#111111',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-229">
      <div className="mx-auto max-w-4xl" data-id="element-230">
        {/* Header */}
        <div className="mb-8 text-center" data-id="element-231">
          <h2 className="font-black text-white m-0 mb-3 text-[26px]" data-id="element-232">
            🏆 ¿QUÉ AGREGA EL{' '}
            <span className="text-yellow-400" data-id="element-233">SISTEMA EJECUTOR PRO™</span>?
          </h2>
          <p className="mx-auto max-w-2xl text-base text-gray-400 m-0" data-id="element-234">
            El sistema de foco, ejecución e identidad que hace que tu potencial
            se convierta en resultados reales y medibles.
          </p>
        </div>

        {/* Swipe hint mobile */}
        <p className="text-xs text-gray-500 text-center mb-2 sm:hidden flex items-center justify-center gap-1" data-id="element-235">
          <span data-id="element-236">👆</span> Deslizá para ver la tabla completa
        </p>

        {/* Comparison Table */}
        <div className="mb-10 overflow-x-auto border border-yellow-400/20 rounded-xl shadow-sm touch-pan-x" style={{
        backgroundColor: 'rgba(255,255,255,0.02)',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-237">
          <div className="min-w-[600px]" data-id="element-238">
            {/* Table Header */}
            <div className="grid grid-cols-3" style={{
            backgroundColor: 'rgba(255,255,255,0.03)'
          }} data-id="element-239">
              <div className="p-3 text-sm font-bold text-gray-300" data-id="element-240">
                Situación
              </div>
              <div className="p-3 text-center text-sm font-bold text-gray-500 border-l border-yellow-400/20" data-id="element-241">
                Sin Sistema Ejecutor PRO
              </div>
              <div className="p-3 text-center text-sm font-bold text-yellow-400 border-l border-yellow-400/20" data-id="element-242">
                Con Sistema Ejecutor PRO
              </div>
            </div>

            {/* Table Rows */}
            {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-white/5' : ''}`} data-id="element-243">
                <div className="p-3 text-xs sm:text-sm text-gray-300" data-id="element-244">
                  {row.situation}
                </div>
                <div className="p-3 text-xs sm:text-sm text-gray-500 border-l border-white/5 bg-white/[0.02]" data-id="element-245">
                  {row.without}
                </div>
                <div className="p-3 text-xs sm:text-sm text-gray-200 border-l border-white/5 bg-yellow-400/5" data-id="element-246">
                  {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* Includes Section */}
        <h3 className="text-xl font-black text-center text-white m-0 mb-6" data-id="element-247">
          ✅ SISTEMA EJECUTOR PRO™ INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-248">
          {blocks.map(block => <div key={block.title} className={`border border-yellow-400/20 rounded-lg p-4 shadow-sm ${block.span ? 'md:col-span-2' : ''}`} style={{
          backgroundColor: 'rgba(234, 179, 8, 0.03)'
        }} data-id="element-249">
              <h4 className="text-base font-bold text-yellow-400 m-0 mb-1" data-id="element-250">
                {block.emoji} {block.title}
              </h4>
              <p className="text-xs text-gray-400 m-0" data-id="element-251">{block.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}